import _ from 'lodash'
import { useState } from 'react'
import * as authApi from './auth-api'
import useCountDown from './use-count-down'
import { isErrorExist, convertResponseToErrorObject } from '../../omnitech-error'

function useEmailToken(defaultCountFrom = 60) {
  const [emailTokenDisable, updateEmailTokenDisable] = useState(false)
  const { count, startCounter, resetCounter } = useCountDown(defaultCountFrom, () => {
    updateEmailTokenDisable(false)
  })

  const sendEmailToken = async email => {
    try {
      updateEmailTokenDisable(true)
      // TODO: tidy the result and return
      const result = await authApi.createEmailToken({ email })
      startCounter()
      return result
    } catch (error) {
      updateEmailTokenDisable(false)
      const data = _.get(error, 'response.data', {})

      if (isErrorExist(data)) {
        const errorObject = convertResponseToErrorObject(data, {useResponseMessage: true})

        throw errorObject
      }

      throw new Error(error)
    }
  }

  const resetCounterEmailToken = () => {
    resetCounter()
    updateEmailTokenDisable(false)
  }

  return {
    sendEmailToken,
    emailTokenCountDown: count,
    emailTokenDisable,
    resetCounterEmailToken
  }
}

export default useEmailToken
